import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import SeverityBadge from "../components/SeverityBadge";
import { Badge } from "../components/ui/badge";
import { formatDate } from "../lib/format";

export default function Covenants() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/covenants").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="covenants-page">
      <PageHeader title="Covenant" subtitle={`${data.length} covenant aktif`} />
      {loading ? <div className="text-sm text-muted-foreground">Memuat…</div> : (
        <DataTable
          testId="covenants-table"
          searchKeys={["covenant_id", "covenant_type", "facility_id"]}
          columns={[
            { header: "Covenant ID", cell: (r) => <span className="mono">{r.covenant_id}</span> },
            { header: "Tipe", key: "covenant_type" },
            { header: "Facility ID", cell: (r) => <span className="mono">{r.facility_id}</span> },
            { header: "Threshold", cell: (r) => <span className="mono">{r.threshold_value}</span>, align: "right" },
            { header: "Actual", cell: (r) => <span className={`mono ${r.status === "Breach" ? "text-[#D0021B] font-bold" : ""}`}>{r.actual_value}</span>, align: "right" },
            { header: "Tanggal Ukur", cell: (r) => <span className="mono text-xs">{formatDate(r.measurement_date)}</span> },
            { header: "Status", cell: (r) => r.status === "Breach" ? <SeverityBadge severity="critical">BREACH</SeverityBadge> : <Badge variant="outline">Compliant</Badge> },
          ]}
          data={data}
        />
      )}
    </div>
  );
}
